import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { userModel } from 'src/app/authentication/models/sign-in';
import { BaseComponent } from '../components/base/base.component';

@Injectable({
  providedIn: 'root'
})
export class StorageService extends BaseComponent {
  private keys = ['job', 'quote', 'staff', 'invoice'];
  constructor(private router: Router) {
    super();
  }

  setLocalStorageTokenInfo(tokenInfo: any) {
    localStorage['tokenInfo'] = JSON.stringify(tokenInfo);
  }

  setLocalStorageUserInfo(userInfo: userModel) {
    localStorage['userInfo'] = JSON.stringify(userInfo);
  }

  clearUserStorageInfo() {
    localStorage.removeItem('userInfo');
  }

  clearLocalStorageInfo() {
    localStorage.removeItem('tokenInfo');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('fcm');
  }

  getAccessToken(): string {
    return localStorage.getItem("tokenInfo") ? JSON.parse(localStorage.getItem("tokenInfo") as any).access : '';
  }

  getRefreshToken(): string {
    return localStorage.getItem("tokenInfo") ? JSON.parse(localStorage.getItem("tokenInfo") as '').refresh : '';
  }

  getUserInfo(): any {
    return localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo") as any) : null;
  }

  getOrganizationId(): any {
    return localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo") as '').organization_id : null;
  }

  getUserId(): any {
    return localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo") as '').user_profile_id : null;
  }

  getUserName(): any {
    return localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo") as '').user_name : null;
  }

  setLanguage(language: string) {
    localStorage.setItem('selected-lng', language);
  }

  getLanguage(): any {
    return localStorage.getItem("selected-lng") ? localStorage.getItem("selected-lng") : 'en';
  }

  setFcmToken(token: string) {
    localStorage.setItem("fcm", token);
  }

  getFcmToken(): string | null {
    return localStorage.getItem("fcm") ? localStorage.getItem("fcm") : '';
  }

  getPage(): number {
    return 1;
  }

  getLimit(is_dropdown: boolean = false): number {
    if (is_dropdown)
      return 1000;
    else
      return 10;
  }

  getDefaultLimit(is_dropdown: boolean = false): number {
    if (is_dropdown)
      return 1000;
    else
      return 100;
  }

  getPageLimitItems() {
    return [10, 25, 50, 100]
  }

  getCurrentDate(): string | null {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const day = today.getDate().toString().padStart(2, '0');
    return `${day}-${month}-${year}`;
  }

  setJobId(value: any) {
    localStorage.setItem("JOBID", value);
  }

  getToken(): string {
    let token = '947332cb-08ab-4f3c-b70c-43c82147a91e';
    return token;
  }

  setPageItems(value: any) {
    localStorage.setItem("PERPAGE", value);
  }

  setLoginInfo(value: any): any {
    let dataString = JSON.stringify(value);
    localStorage.setItem("LoginDetail", dataString);
  }

  setUserId(id: any) {
    localStorage.setItem("UserId", id);
  }

  get_UserId() {
    return localStorage.getItem("UserId");
  }

  getJobId() {
    return localStorage.getItem("JOBID");
  }

  //Themes
  setColorScheme(colorScheme: any) {
    localStorage.setItem('colorScheme', colorScheme);
  }

  setMenuMode(MenuMode: any) {
    localStorage.setItem('menuMode', MenuMode);
  }

  setmenuProfilePosition(menuProfilePosition: any) {
    localStorage.setItem('menuProfilePosition', menuProfilePosition);
  }

  setInputStyle(inputStyle: any) {
    localStorage.setItem('inputStyle', inputStyle);
  }

  setMenuTheme(menuTheme: any) {
    localStorage.setItem('menuTheme', menuTheme);
  }

  setRipple(ripple: any) {
    localStorage.setItem('ripple', ripple);
  }

  setTopbarTheme(topbarTheme: any) {
    localStorage.setItem('topbarTheme', topbarTheme);
  }

  setComponentTheme(componentTheme: any) {
    localStorage.setItem('componentTheme', componentTheme);
  }

  setScale(scale: any) {
    localStorage.setItem('scale', scale);
  }

  getScale(): number {
    const scale = localStorage.getItem('scale');
    return scale !== null ? +scale : 13;
  }

  getComponentTheme(): any {
    return localStorage.getItem('componentTheme') ? localStorage.getItem('componentTheme') : 'indigo';
  }

  getTopbarTheme(): any {
    return localStorage.getItem('topbarTheme') ? localStorage.getItem('topbarTheme') : 'indigo';
  }

  getMenuTheme(): any {
    return localStorage.getItem('menuTheme') ? localStorage.getItem('menuTheme') : 'light';
  }

  getRipple(): any {
    return localStorage.getItem('ripple') ? localStorage.getItem('ripple') : 'true';
  }

  getInputStyle(): any {
    return localStorage.getItem('inputStyle') ? localStorage.getItem('inputStyle') : 'outlined';
  }

  getmenuProfilePosition(): any {
    return localStorage.getItem('menuProfilePosition') ? localStorage.getItem('menuProfilePosition') : 'end';
  }

  getMenuMode(): any {
    return localStorage.getItem('menuMode') ? localStorage.getItem('menuMode') : 'static';
  }

  getColorScheme(): any {
    return localStorage.getItem('colorScheme') ? localStorage.getItem('colorScheme') : 'light';
  }

  popupWidth() {
    return '50%';
  }

  popupWidthLarge() {
    return '60%';
  }

  popupWidthSmall() {
    return '30%';
  }

  getTimeSheetApproval(): boolean {
    return localStorage.getItem("org-setting") ? JSON.parse(localStorage.getItem("org-setting") as '').is_timesheet_approval : false;
  }

  getExpenseApproval(): boolean {
    return localStorage.getItem("org-setting") ? JSON.parse(localStorage.getItem("org-setting") as '').is_cost_approval : false;
  }

  getMasterAdmin(): boolean {
    return localStorage.getItem("org-setting") ? JSON.parse(localStorage.getItem("org-setting") as '').is_master_admin : false;
  }

  getRolesTypeId(): any {
    return localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo") as '').roles_type_id : null
  }

  setName(key: string, value: string) {
    sessionStorage.setItem(key, value);
    this.clearOthers(key);
  }

  getName(key: string): string | null {
    return sessionStorage.getItem(key);
  }

  clearOthers(excludeKey: string) {
    this.keys.forEach(k => {
      if (k !== excludeKey) {
        sessionStorage.removeItem(k);
      }
    });
  }
}